/**
 * Created by ori on 28/07/16.
 */

import React from 'react'
import HomeFirst from '../components/HomeFirst';
import HomeSecond from '../components/HomeSecond';
import HomeThird from '../components/HomeThird';
import HomeFour from '../components/HomeFour';
import HomeFive from '../components/HomeFive';
import HomeSix from  '../components/HomeSix';
import HomeFooter from  '../components/HomeFooter';
import cookie from 'react-cookie';
import HomeHeader from '../components/HomeHeader';
// require('../../node_modules/bootstrap/dist/css/bootstrap.min.css')
// require('../../node_modules/bootstrap-material-design/dist/css/bootstrap-material-design.min.css');
// require('../../css/material_ui_custom.css');

//src="https://youtube.com/embed/lUtnas5ScSE?autoplay=1&controls=0&showinfo=0&autohide=1"


export default class Home extends React.Component {

	componentDidMount(){

		console.log("track page");
		window.analytics.page('Home');
	}

	render(){
		return (
			<div>
			  <HomeHeader/>
			  <div className="home_main"></div>
		      <HomeFirst></HomeFirst>
		      <HomeSecond></HomeSecond>
		      <HomeThird></HomeThird>
		      <HomeSix></HomeSix>
		      <HomeFour></HomeFour>
		      {/*<HomeFive></HomeFive>*/}

		      <HomeFooter></HomeFooter>

		    </div>
		);
	}

}



// WEBPACK FOOTER //
// ./src/js/pages/Home.js